/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { format } from 'date-fns';
import COLORS from '../../core/constants/colors';

const ReductionChart = React.memo(function ReductionChart({ series }: any): JSX.Element {
  const options: Highcharts.Options = {
    chart: {
      type: 'column',
      zoomType: 'x',
      height: 350,
      backgroundColor: 'transparent',
      spacingRight: 10,
      animation: false,
    },

    credits: {
      enabled: false,
    },
    colors: [COLORS.blue, COLORS.red, COLORS.orange, COLORS.purple, COLORS.green],
    title: {
      text: undefined,
    },

    tooltip: {
      // valueDecimals: undefined,
      // xDateFormat: '%A, %b %e %Y',
      useHTML: true,
      formatter: function formatter() {
        return `
          <p>${this.y.toFixed(2)} mcm/d</p>
          <p>${format(this.x, 'yyyy-MM-dd')}</p>
        `;
      },
    },

    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%d. %b',
      },
      labels: {
        style: {
          textOverflow: 'visible',
          whiteSpace: 'nowrap',
        },
      },
    },

    yAxis: {
      lineWidth: 0,
      title: {
        text: null,
      },
    },

    legend: {
      enabled: false,
      align: 'center',
      itemMarginBottom: 12,
      symbolPadding: 8,
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        animation: false,
      },
      column: {
        pointPadding: 0.1,
      },
    },

    time: {
      useUTC: true,
    },

    series,
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
});

export default ReductionChart;
